export default "__VITE_ASSET__CuzS_lFg__"